export default "__VITE_ASSET__233b97b3__"